import {
  Tooltip
} from "antd";
import dayjs from "dayjs";
import "dayjs/locale/vi"; // Để dayjs cũng hiển thị tiếng Việt
import React from "react";
import { ListFieldCustomer } from "../../../api/Customer_V2/customerApi_V2";
import { info_cicrle } from "../../../components/ExportImgFigma";
import { NO_DATA, NO_VIEW } from "../../../services/data";
import './stylestabs.scss'

dayjs.locale("vi");

interface Prop {
  isTooltip?: boolean;
  isEditing?: boolean;
  isIndividual: boolean
  fieldCustomer: ListFieldCustomer;
}

const ItemsInfomation: React.FC<Prop> = ({
  isTooltip = false,
  isEditing = false,
  isIndividual,
  fieldCustomer,
}) => {
  const { fieldLabel, value, view, fieldCode } = fieldCustomer;
  const typeCodeIndividual = ['cus_dms_id_card_no', 'cus_birth_day']
  const typeCodeOrganization = ['cus_tax_reg_no_dms', 'cus_founding_date']

  // lấy value của những object có Primary
  function getFieldValueObject(value: any) {
    if (value === null || value === undefined) return NO_DATA;
    if (typeof value === "object" && !Array.isArray(value)) {
      return value.title ?? NO_DATA;
    }
    // if (Array.isArray(value)) {
    //   return value.find((item: any) => item.isPrimary === 1) ?? NO_DATA;
    // }
    if (Array.isArray(value)) {
      let valueTmp: string[] = []
      value.map((item) => {
        if (typeof item === "object") {
          valueTmp.push(item.name)
        } else {
          valueTmp.push(item)
        }
      })
      return valueTmp.length > 0 ? valueTmp[0] : NO_DATA;
    }
    return value;
  }

  function getFieldValueObjectTooltip(value: any) {
    if (value === null || value === undefined) return NO_DATA;
    if (typeof value === "object" && !Array.isArray(value)) {
      return value.title ?? NO_DATA;
    }
    if (Array.isArray(value)) {
      let valueTmp: string[] = []
      value.map((item) => {
        if (typeof item === "object") {
          valueTmp.push(item.name)
        } else {
          valueTmp.push(item)
        }
      })
      return valueTmp.length > 0
        ?
        valueTmp.map((item, i) => (
          <div key={i} className="custom-page-css flex flex-col">
            {item}
          </div>
        ))
        :
        NO_DATA;
    }
    return value;
  }

  return (
    <>
      {
        (isIndividual && typeCodeOrganization.includes(fieldCode))
          ||
          (!isIndividual && typeCodeIndividual.includes(fieldCode))
          ?
          ''
          :
          isTooltip ? (
            // === TOOLTIP ===
            <div className="custom-page-css w-full flex justify-between">
              <div className="custom-page-css w-full flex items-center column-gap-2 flex-wrap ">

                <div className="flex items-center">
                  <span className="custom-page-css text-sm font-medium text-000000">{fieldLabel}:</span>

                </div>
                <div className="custom-page-css text-sm font-light text-000000">
                  {view ? (value ? getFieldValueObject(value) : NO_DATA) : NO_VIEW}
                </div>




              </div>
              {
                (view && value.length > 1) &&
                < Tooltip
                  placement="right"
                  color="white"
                  title={
                    <div
                      style={{
                        maxHeight: 400,       // chiều cao cố định
                        overflowY: "auto",    // bật scroll dọc
                      }}
                      className="space-y-2"
                    >
                      <div className="custom-page-css flex items-center gap-2 h-fit" >
                        <span className="color-bage-custom fs-14">
                          {getFieldValueObjectTooltip(value)}
                        </span>
                      </div>
                    </div>
                  }
                >
                  <div className="action-icons action-icons-bage ml-auto px-2 fs-14 cursor-pointer custom-page-css h-fit">
                    <div className="font-light color-bage" >{value?.length ?? 0}</div>
                    <img src={info_cicrle} alt="Avatar" />
                  </div>
                </Tooltip>
              }
            </div>
          ) : (
            <div className="custom-page-css w-full flex items-center column-gap-2 flex-wrap ">
              <div className="custom-page-css flex items-center ">
                <label className="custom-page-css text-sm font-medium text-000000">{fieldLabel}:</label>
              </div>

              <div className="custom-page-css text-sm font-light  text-000000">
                {view ? (value ? getFieldValueObject(value) : NO_DATA) : NO_VIEW}
              </div>
            </div>
          )
      }
    </>
  );
};

export default React.memo(ItemsInfomation);
